module.exports = _.slice;